import React, { useState, useEffect } from 'react';
import { ProductResultsContext } from './ProductResultsContext';
import { sendSponsoredContentAnalytics } from '../utils/sendSponsoredContentAnalytics';

const ProductResults = (props) => {
  const {
    children = null, data: propData, queryVariables = {}, // eslint-disable-line
    pageContext, error, loading, responseLoading } = props; // eslint-disable-line
  const [data, setData] = useState(propData);

  useEffect(() => {
    setData(propData);
  }, [propData]);

  // send sponsored product render rate metrics
  useEffect(() => {
    sendSponsoredContentAnalytics(data?.searchModel?.products, loading);
  }, [data?.searchModel?.products, loading]);

  const resp = {
    data,
    queryVariables,
    pageContext,
    error,
    loading,
    responseLoading,
    setData
  };

  return (
    <ProductResultsContext.Provider value={resp}>
      {children}
    </ProductResultsContext.Provider>
  );
};

export { ProductResults };
